import { render, staticRenderFns } from "./hdcomplaint.vue?vue&type=template&id=787ab1dd&scoped=true&"
import script from "./hdcomplaint.vue?vue&type=script&lang=js&"
export * from "./hdcomplaint.vue?vue&type=script&lang=js&"
import style0 from "./hdcomplaint.vue?vue&type=style&index=0&id=787ab1dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787ab1dd",
  null
  
)

export default component.exports